import script from "./PatientMerge.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientMerge.vue?vue&type=script&lang=ts&setup=true"

import "./PatientMerge.vue?vue&type=style&index=0&id=47d30968&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d30968"]])

export default __exports__